import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faWifi, faCode, faMicrochip} from '@fortawesome/free-solid-svg-icons'
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "Linux",
    "VSCode",
    "QT Framework",
    "Git",
    "Jenkins",
    "Subversion",
    "C++",
    "C",
    "Python",
    "Arduino",
    "ESP32",
];

const labelsSecond = [
    "IoT",
    "Edge AI",
    "Microcontrollers",
    "EPLAN Electric P8",
    "PLC Programming",
    "Kicad",
    "Wiring diagrams",
    "High level design",
    "Firmware development",
];

const labelsThird = [
    "Clouflare",
    "Amazon Web Services (AWS)",
    "LoRa",
    "MQTT",
    "Self-Hosting",

];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faCode} size="3x"/>
                    <h3>Firmware Development</h3>
                    <p>I have developed many solutions for digital technology solutions. From defense electronics to nature-focused IoT, my skillset is formed by a wide range of technologies. </p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faMicrochip} size="3x"/>
                    <h3>Smart Electronics Design</h3>
                    <p>The smarter a process is, the less attention it requests. I am determined to implement smart solutions wherever it is worth to do so to improve productivity and reliability.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faWifi} size="3x"/>
                    <h3>Networks and Cybersecurity</h3>
                    <p>"Information is the new currency", that is why I always find a way to establish secure connections with my creations and perform reliable data mining for smart solutions.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;